import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BeritaCard from "./BeritaCard";
import VenoBox from "venobox";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
import "./direktorat/dr.css";
import Kota from "../component/dumy/dataKota";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import "dayjs/locale/id";
import "dayjs/locale/en";
import { useTranslation } from "react-i18next";
import SkeletonCardBerita from "../component/skeleton/CardBerita";
import { useCookies } from "react-cookie";

const KdeksDetail = () => {
    const { id, slug } = useParams(); // Mendapatkan parameter id dan slug dari URL
    const navigate = useNavigate();
    const [cookies] = useCookies(["i18next"]);
    const { t } = useTranslation();

    // ==========================================
    // DEKLARASI STATE YANG HILANG
    // ==========================================
    const [dataKota, setDataKota] = useState([]);
    const [listdataKota, setListDataKota] = useState(null);

    const [loadingNew, setLoadingNew] = useState(true);
    const [posts, setPosts] = useState([]);

    const [loadingKdeks, setLoadingKdeks] = useState(true);
    const [postKdeks, setPostKdeks] = useState(null);

    const [loadingOpini, setLoadingOpini] = useState(true);
    const [postsOpini, setPostsOpini] = useState([]);

    const [loadingPoto, setLoadingPoto] = useState(true);
    const [posts_photo, setPostsPhoto] = useState([]);

    const [posts1, setPosts1] = useState([]);
    const [postTentang, setPostTentang] = useState(null);

    // ==========================================
    // HELPER FUNCTIONS
    // ==========================================
    const formatDate = (date, locale = "en") => {
        dayjs.locale(locale);
        return dayjs(date).format("DD MMMM YYYY");
    };

    const convertToSlug = (title) => {
        if (!title) return "";
        return title
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-");
    };

    // ==========================================
    // USE EFFECTS (DATA FETCHING)
    // ==========================================

    // 1. Ambil Data Berita
    useEffect(() => {
        const fetchNews = async () => {
            setLoadingNew(true);
            try {
                const url = process.env.REACT_APP_API_URL;
                const endpoint = process.env.REACT_APP_API_KDEKS_NEWS + "/" + id;
                const response = await axios.get(`${url}${endpoint}`);
                setPosts(response.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoadingNew(false);
            }
        };
        fetchNews();
    }, [id]);

    // 2. Ambil Data Profil Provinsi KDEKS
    useEffect(() => {
        const fetchKdeksProfile = async () => {
            setLoadingKdeks(true);
            try {
                const url = process.env.REACT_APP_API_URL;
                const response = await axios.get(`${url}/api_about_province_kdeks/${id}`);
                if (response.data && response.data.length > 0) {
                    setPostKdeks(response.data[0]);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoadingKdeks(false);
            }
        };
        fetchKdeksProfile();
    }, [id]);

    // 3. Ambil Data Opini (dan init VenoBox)
    useEffect(() => {
        const fetchOpini = async () => {
            setLoadingOpini(true);
            try {
                const url = process.env.REACT_APP_API_URL;
                const endpoint = process.env.REACT_APP_API_KDEKS_OPINI + "/" + id;
                const response = await axios.get(`${url}${endpoint}`);
                setPostsOpini(response.data);

                // Init VenoBox dengan delay agar DOM ter-render dulu
                setTimeout(() => {
                    if (document.querySelectorAll(".my-image-links-c").length > 0) {
                        new VenoBox({
                            selector: ".my-image-links-c",
                            numeration: true,
                            infinigall: true,
                            share: true,
                            spinner: "swing",
                            spinColor: "#5A8DEE",
                            titlePosition: "bottom",
                            toolsColor: "#ffffff",
                            titleattr: "data-title",
                            titleStyle: "block",
                        });
                    }
                }, 500);
            } catch (err) {
                console.error(err);
            } finally {
                setLoadingOpini(false);
            }
        };
        fetchOpini();

        // Cleanup VenoBox
        return () => {
            const elements = document.querySelectorAll(".my-image-links-c");
            elements.forEach((el) => {
                el.removeAttribute("data-venobox-initialized");
            });
            const venoboxOverlay = document.querySelector(".vbox-overlay");
            if (venoboxOverlay) {
                venoboxOverlay.remove();
            }
        };
    }, [id]);

    // 4. Ambil Data Galeri Foto
    useEffect(() => {
        const fetchPhoto = async () => {
            setLoadingPoto(true);
            try {
                const url = process.env.REACT_APP_API_URL;
                const endpoint = process.env.REACT_APP_API_KDEKS_PHOTO + "/" + id;
                const response = await axios.get(`${url}${endpoint}`);
                setPostsPhoto(response.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoadingPoto(false);
            }
        };
        fetchPhoto();
    }, [id]);

    // 5. Ambil Data Struktur Organisasi
    useEffect(() => {
        const fetchPostsStructure = async () => {
            try {
                const url = process.env.REACT_APP_API_URL;
                const endpoint = "/multistructurekdeks/" + id;
                const response = await axios.get(`${url}${endpoint}`);
                setPosts1(response.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchPostsStructure();
    }, [id]);

    // 6. Ambil Data Tentang Provinsi
    useEffect(() => {
        const fetchPostsTentang = async () => {
            try {
                const url = process.env.REACT_APP_API_URLKDEKS;
                const endpoint = process.env.REACT_APP_API_KDEKS_TENTANG_PROV;
                if (url && endpoint) {
                    const response = await axios.get(`${url}${endpoint}/${id}`);
                    if (response.data && response.data.length > 0) {
                        setPostTentang(response.data[0]);
                    }
                }
            } catch (err) {
                console.error(err);
            }
        };
        fetchPostsTentang();
    }, [id]);

    // 7. Kelola Data Kota dummy
    useEffect(() => {
        if (Kota) {
            setDataKota(Kota);
        }
    }, []);

    useEffect(() => {
        if (dataKota.length > 0 && slug) {
            const foundItem = dataKota.find(
                (kneks) => convertToSlug(kneks.title) === slug
            );
            setListDataKota(foundItem);
        }
    }, [dataKota, slug]);

    // 8. Inisialisasi Swiper KDEKS (Berita/Agenda)
    useEffect(() => {
        let swipersInstance = null;
        if (posts.length > 0) {
            if (document.querySelector(".swiper-kdeks")) {
                swipersInstance = new Swiper(".swiper-kdeks", {
                    loop: true,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    autoplay: { delay: 2500 },
                    breakpoints: {
                        640: { slidesPerView: 2, spaceBetween: 20 },
                        768: { slidesPerView: 3, spaceBetween: 30 },
                        1024: { slidesPerView: 4, spaceBetween: 20 },
                    },
                });
            }
        }
        return () => {
            if (swipersInstance) swipersInstance.destroy(true, true);
        };
    }, [posts]);

    useEffect(() => {
        let swiperAgendaInstance = null;
        if (document.querySelector(".swiper-kdeks-agenda")) {
            swiperAgendaInstance = new Swiper(".swiper-kdeks-agenda", {
                loop: true,
                pagination: { el: ".swiper-pagination", clickable: true },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    1024: { slidesPerView: 4, spaceBetween: 20 },
                },
            });
        }
        return () => {
            if (swiperAgendaInstance) swiperAgendaInstance.destroy(true, true);
        };
    }, []);

    // ==========================================
    // RENDER
    // ==========================================
    return (
        <>
            <div itemScope itemType="https://schema.org/Organization">
                <meta
                    itemProp="name"
                    content={cookies.i18next === "en" ? postKdeks?.title_en : postKdeks?.title}
                />
                <meta
                    itemProp="description"
                    content={cookies.i18next === "en" ? postKdeks?.historys_en : postKdeks?.historys}
                />
                <meta
                    itemProp="image"
                    content="https://www.kneks.go.id/assets/image/logoKdeks.png"
                />
            </div>

            <div className="page-wrapper">
                {/* BANNER SECTION */}
                <section
                    className="page-banner-kdeks position-relative d-flex align-items-center justify-content-center"
                    style={{
                        minHeight: "400px",
                        backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url("/assets/image/bg/dash.jpg")`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundAttachment: "fixed",
                    }}
                >
                    <div className="container text-center position-relative z-1 mt-4">
                        <h1
                            className="text-white fw-bold display-4 mb-3"
                            style={{ textShadow: "0 2px 10px rgba(0,0,0,0.3)" }}
                        >
                            {cookies.i18next === "en" ? postKdeks?.title_en : postKdeks?.title}
                        </h1>
                        <p
                            className="text-white-50 fs-5 mb-0"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                        >
                            {t("dukunganKdeks")}
                        </p>
                    </div>
                </section>

                {/* TENTANG KDEKS SECTION */}
                <section className="about-one-section-kdeks py-5">
                    <div className="container">
                        <div className="row row-gutter-y-40 align-items-center">
                            <div className="col-lg-12 col-xl-6">
                                <div className="about-one-image d-flex justify-content-center">
                                    {loadingKdeks ? (
                                        <div className="skeleton-kdeks skeleton-kdeks-img"></div>
                                    ) : (
                                        <img
                                            src={postKdeks?.images || "/assets/image/logoKdeks.png"}
                                            alt={postKdeks?.title || "logo"}
                                            style={{ maxHeight: "300px", objectFit: "contain" }}
                                            className="img-fluid"
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="col-lg-12 col-xl-6">
                                <div className="about-one-inner-x">
                                    {loadingKdeks ? (
                                        <>
                                            <div className="skeleton-kdeks skeleton-kdeks-text"></div>
                                            <div
                                                className="skeleton-kdeks skeleton-kdeks-text"
                                                style={{ width: "60%" }}
                                            ></div>
                                        </>
                                    ) : (
                                        <>
                                            <h2 className="section-title">
                                                {t("tentangKamikdeks")}{" "}
                                                {cookies.i18next === "en" ? postKdeks?.title_en : postKdeks?.title}
                                            </h2>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: cookies.i18next === "en" ? postKdeks?.abouts_en : postKdeks?.abouts,
                                                }}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* STRUKTUR ORGANISASI SECTION */}
                <section className="portfolio-section py-5">
                    <div className="container">
                        <div className="section-title-box text-center">
                            <h2 className="section-title">{t("menu.strukturOrganisasi")}</h2>
                        </div>
                        <div className="row row-gutter-y-40 text-center">
                            {posts1.length > 0 ? (
                                <div>
                                    {Object.values(posts1).map((items1) => (
                                        <React.Fragment key={items1.id}>
                                            <div className="row row-gutter-30 mb-4">
                                                <div className="col-12 col-sm-6 col-md-4 col-lg-4 offset-lg-4 offset-md-4">
                                                    <div className="team-card-rev">
                                                        <div className="team-card-img-rev">
                                                            <a href={`/struktur-organisasi/${convertToSlug(items1?.position)}?tbl=${btoa("pejabat_kdeks")}&keyid=${btoa(items1?.id)}`}>
                                                                <img
                                                                    src={items1?.photo ? `${items1?.photo}` : "assets/image/defaulttumbnail.jpeg"}
                                                                    className="img-fluid"
                                                                    alt="img-pejabat"
                                                                />
                                                            </a>
                                                            <div className="team-card-icon-rev"></div>
                                                        </div>
                                                        <div className="team-card-content-rev">
                                                            <h4>
                                                                <a href={`/struktur-organisasi/${convertToSlug(items1?.position)}?tbl=${btoa("pejabat_kdeks")}&keyid=${btoa(items1?.id)}`}>
                                                                    {items1?.name}
                                                                </a>
                                                            </h4>
                                                            <p>
                                                                {cookies.i18next === "id" ? items1?.position : items1?.position_en}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Sub-Anggota Mapping */}
                                            {items1?.ag?.length > 0 && (
                                                <div className="row mb-4 justify-content-center">
                                                    {items1?.ag.map((item2) => (
                                                        <div className="col-12 col-sm-6 col-md-4 mb-4" key={item2.id}>
                                                            <div className="team-card-rev">
                                                                <div className="team-card-img-rev">
                                                                    <a href={`/struktur-organisasi/${convertToSlug(item2?.position)}?tbl=${btoa("anggota_kdeks")}&keyid=${btoa(item2?.id)}`}>
                                                                        <img
                                                                            src={item2?.photo ? `${item2?.photo}` : "assets/image/defaulttumbnail.jpeg"}
                                                                            className="img-fluid"
                                                                            alt="img-anggota"
                                                                        />
                                                                    </a>
                                                                </div>
                                                                <div className="team-card-content-rev">
                                                                    <h4>
                                                                        <a href={`/struktur-organisasi/${convertToSlug(item2?.position)}?tbl=${btoa("anggota_kdeks")}&keyid=${btoa(item2?.id)}`}>
                                                                            {item2?.name}
                                                                        </a>
                                                                    </h4>
                                                                    <p>
                                                                        {cookies.i18next === "id" ? item2?.position : item2?.position_en}
                                                                    </p>
                                                                </div>

                                                                {item2?.sag?.length > 0 && (
                                                                    <ul className="list-unstyled text-left mt-3">
                                                                        {item2?.sag.map((item3) => (
                                                                            <li className="d-flex align-items-center mb-2" key={item3.id}>
                                                                                <img
                                                                                    src={item3?.photo ? `${item3.photo}` : "assets/image/defaulttumbnail.jpeg"}
                                                                                    alt="img-sub"
                                                                                    className="rounded-circle me-2"
                                                                                    style={{ width: "40px", height: "40px", objectFit: "cover" }}
                                                                                />
                                                                                <span className="text-small">
                                                                                    <b>
                                                                                        <a href={`/struktur-organisasi/${convertToSlug(item3?.position)}?tbl=${btoa("sub_anggota_kdeks")}&keyid=${btoa(item3?.id)}`} style={{ color: "black" }}>
                                                                                            {item3?.name}
                                                                                        </a>
                                                                                    </b>
                                                                                    <br />
                                                                                    {cookies.i18next === "id" ? item3?.position : item3?.position_en}
                                                                                </span>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                            ) : (
                                <div className="col-12 py-5 text-center">
                                    <h4 className="text-muted fw-normal" style={{ letterSpacing: "1px" }}>
                                        Coming Soon
                                    </h4>
                                </div>
                            )}
                        </div>
                    </div>
                </section>

                <style>
                    {`
                    .custom-pills .nav-link {
                        color: #555;
                        background-color: transparent;
                        border: 1px solid transparent;
                        transition: all 0.3s ease;
                    }
                    .custom-pills .nav-link:hover {
                        color: #00994B;
                        background-color: #f8f9fa;
                        border-color: #e9ecef;
                    }
                    .custom-pills .nav-link.active {
                        background-color: #00994B;
                        color: white;
                        box-shadow: 0 4px 15px rgba(0, 153, 75, 0.3);
                    }
                    `}
                </style>

                {/* TABS BERITA, OPINI, GALERI */}
                <section className="content-tabs-section py-5">
                    <div className="container">
                        <div className="p-0">
                            <ul className="nav nav-pills mb-5 custom-pills justify-content-center" id="pills-tab" role="tablist" style={{ gap: "10px" }}>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link active rounded-pill px-4 py-2 fw-medium"
                                        id="pills-berita-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-berita"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-berita"
                                        aria-selected="true"
                                    >
                                        <i className="fa-solid fa-newspaper me-2"></i>
                                        {t("beritaTerkait")}
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link rounded-pill px-4 py-2 fw-medium"
                                        id="pills-opini-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-opini"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-opini"
                                        aria-selected="false"
                                    >
                                        <i className="fa-solid fa-comments me-2"></i>
                                        {t("menu.opini")}
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link rounded-pill px-4 py-2 fw-medium"
                                        id="pills-galeri-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-galeri"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-galeri"
                                        aria-selected="false"
                                    >
                                        <i className="fa-solid fa-images me-2"></i>
                                        {t("menu.galeriFoto")}
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content" id="pills-tabContent">
                                {/* TAB BERITA */}
                                <div className="tab-pane fade show active" id="pills-berita" role="tabpanel" aria-labelledby="pills-berita-tab">
                                    <div className="row row-gutter-30">
                                        {loadingNew ? (
                                            Array(4).fill().map((_, index) => (
                                                <div className="col-lg-3 col-md-6 d-flex" key={index}>
                                                    <SkeletonCardBerita />
                                                </div>
                                            ))
                                        ) : posts.length > 0 ? (
                                            posts.slice(0, 4).map((item) => (
                                                <div className="col-lg-3 col-md-6 mb-4" key={item.id}>
                                                    <BeritaCard item={item} />
                                                </div>
                                            ))
                                        ) : (
                                            <div className="col-12 py-5">
                                                <div className="text-center text-muted">
                                                    <i className="fa-regular fa-folder-open fs-1 mb-3"></i>
                                                    <p>Tidak ada berita tersedia.</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* TAB OPINI */}
                                <div className="tab-pane fade" id="pills-opini" role="tabpanel" aria-labelledby="pills-opini-tab">
                                    <div className="row row-gutter-30">
                                        {loadingOpini ? (
                                            Array(4).fill().map((_, index) => (
                                                <div className="col-lg-3 col-md-6 d-flex" key={index}>
                                                    <SkeletonCardBerita />
                                                </div>
                                            ))
                                        ) : postsOpini.length > 0 ? (
                                            postsOpini.slice(0, 4).map((item) => (
                                                <div className="col-lg-3 col-md-6" key={item.id}>
                                                    <div className="berita-card">
                                                        <div className="berita-card-imgbox-direktorat" style={{ width: "100%" }}>
                                                            <a href={`/opini-kdeks/${item.id}/${convertToSlug(item.title)}`}>
                                                                <img
                                                                    src="/assets/image/foto-beritas.png"
                                                                    className="img-fluid"
                                                                    alt={item?.title}
                                                                />
                                                            </a>
                                                        </div>
                                                        <div className="berita-content-direktorat-xs">
                                                            <div className="event-card-title pb-2">
                                                                <h4>
                                                                    <a href={`/opini-kdeks/${item?.id}/${convertToSlug(item?.title)}`}>
                                                                        {cookies.i18next === "en" ? item?.title_en : item?.title}
                                                                    </a>
                                                                </h4>
                                                            </div>
                                                            <div className="event-card-info-direktorat">
                                                                <span>
                                                                    {cookies.i18next === "id"
                                                                        ? formatDate(item?.date_created, "id")
                                                                        : formatDate(item?.date_created, "en")}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="col-12 py-5">
                                                <div className="text-center text-muted">
                                                    <i className="fa-regular fa-folder-open fs-1 mb-3"></i>
                                                    <p>Tidak ada opini tersedia.</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* TAB GALERI FOTO */}
                                <div className="tab-pane fade" id="pills-galeri" role="tabpanel" aria-labelledby="pills-galeri-tab">
                                    <div className="row row-gutter-30">
                                        {loadingPoto ? (
                                            Array(4).fill().map((_, index) => (
                                                <div className="col-lg-3 col-md-6 d-flex" key={index}>
                                                    <SkeletonCardBerita />
                                                </div>
                                            ))
                                        ) : posts_photo.length > 0 ? (
                                            posts_photo.slice(0, 4).map((item) => (
                                                <div className="col-md-3 col-lg-3 mb-4" key={item.id}>
                                                    <a
                                                        href={item?.photo || "/assets/image/foto-beritas.png"}
                                                        className="my-image-links-c"
                                                        data-gall="gallery"
                                                        data-title={item?.title}
                                                    >
                                                        <div className="card-box-b card-shadow news-box h-100">
                                                            <div className="img-box-b">
                                                                <img
                                                                    src={item?.photo ? item.photo : "/assets/image/foto-beritas.png"}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = "/assets/image/foto-beritas.png";
                                                                    }}
                                                                    title={cookies.i18next === "id" ? item.title : item.title_en}
                                                                    alt="imgNews"
                                                                    style={{ width: "100%", height: "200px", objectFit: "cover" }}
                                                                    className="img-b img-fluid"
                                                                />
                                                            </div>
                                                            <div className="card-overlay">
                                                                <div className="card-header-b-x-s">
                                                                    <div className="card-title-b-s">
                                                                        <h2 className="title-2-x-s text-white">
                                                                            {cookies.i18next === "id" ? item.title : item.title_en}
                                                                        </h2>
                                                                    </div>
                                                                    <div className="card-date-s">
                                                                        <span className="date-b-s text-white">
                                                                            {cookies.i18next === "id"
                                                                                ? formatDate(item.news_datetime, "id")
                                                                                : formatDate(item.news_datetime, "en")}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="col-12 py-5">
                                                <div className="text-center text-muted">
                                                    <i className="fa-regular fa-folder-open fs-1 mb-3"></i>
                                                    <p>Tidak ada galeri foto tersedia.</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* FOOTER SECTION */}
                <section className="footer pt-5 border-top">
                    <div className="footer-inner">
                        <div className="container">
                            <div className="row">
                                {/* Kolom 1: Logo & Social Media */}
                                <div className="col-lg-4 mb-4">
                                    <div className="footer-widget-logo pb-3">
                                        <a href="/kdeks">
                                            <img
                                                src="/assets/image/logoKdeks.png"
                                                alt="logo"
                                                width="200"
                                            />
                                        </a>
                                    </div>
                                    <div className="footer-widget-socials d-flex gap-3">
                                        <a href={postKdeks?.twitter || "#"} target="_blank" rel="noreferrer" className="text-secondary fs-4">
                                            <i className="fa-brands fa-x-twitter"></i>
                                        </a>
                                        <a href={postKdeks?.facebook || "#"} target="_blank" rel="noreferrer" className="text-secondary fs-4">
                                            <i className="fa-brands fa-facebook"></i>
                                        </a>
                                        <a href={postKdeks?.linkedin || "#"} target="_blank" rel="noreferrer" className="text-secondary fs-4">
                                            <i className="fa-brands fa-linkedin"></i>
                                        </a>
                                        <a href={postKdeks?.instagram || "#"} target="_blank" rel="noreferrer" className="text-secondary fs-4">
                                            <i className="fa-brands fa-instagram"></i>
                                        </a>
                                        <a href={postKdeks?.youtube || "#"} target="_blank" rel="noreferrer" className="text-secondary fs-4">
                                            <i className="fa-brands fa-youtube"></i>
                                        </a>
                                    </div>
                                </div>

                                {/* Kolom 2: Alamat */}
                                <div className="col-lg-4 mb-4">
                                    <div className="footer-widget">
                                        <h4 className="footer-widget-title fw-bold mb-3">{t("alamat")}</h4>
                                        <p className="text-muted">{postKdeks?.address || "Alamat belum tersedia."}</p>
                                    </div>
                                </div>

                                {/* Kolom 3: Kontak */}
                                <div className="col-lg-4 mb-4">
                                    <div className="footer-widget">
                                        <h4 className="footer-widget-title fw-bold mb-3">{t("menu.kontak")}</h4>
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fa-solid fa-envelope me-2 text-muted"></i>
                                            <a href={`mailto:${postKdeks?.email || "#"}`} className="text-muted text-decoration-none">
                                                {postKdeks?.email || "-"}
                                            </a>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <i className="fa-solid fa-phone me-2 text-muted"></i>
                                            <a href={`tel:${postKdeks?.phone_number || "#"}`} className="text-muted text-decoration-none">
                                                {postKdeks?.phone_number || "-"}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Copyright Section */}
                    <div className="bottom-footer py-3 bg-light text-center mt-4">
                        <div className="container">
                            <p className="mb-0 text-muted">
                                © Copyright {new Date().getFullYear()} by {postKdeks?.title || "KDEKS"}
                            </p>
                        </div>
                    </div>
                </section>

            </div>
        </>
    );
};

export default KdeksDetail;